import { render, staticRenderFns } from "./job.vue?vue&type=template&id=6608619e&scoped=true"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608619e",
  null
  
)

export default component.exports